module.exports = __webpack_public_path__ + "static/media/MHRP09N0010.8bf348e2.svg";